import { Grid } from '@material-ui/core';
import ButtonOption from './ButtonOption';
import { ErrorMessage } from '../helpers';

interface ListOption<T> {
    label: React.ReactNode;
    value?: T;
    disabled?: boolean;
    backgroundColor?: string;
}

interface ProductOptionProps<T> {
    name: string;
    options: ListOption<T>[];
    values?: T[];
    showError?: boolean;
    setFieldValue?: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
    onChange?: (value: T, newValues: (T | undefined)[], checked?: boolean) => void;
}
 
export default <T extends any>({ name, options, values, setFieldValue, onChange, showError }: ProductOptionProps<T>) => <>
    {options.map((option, index) => <Grid item key={index} xs={12}>
        <ButtonOption
            disabled={option.disabled}
            backgroundColor={option.backgroundColor}
            checked={values?.includes(option.value!)}
            label={option.label}
            onClick={(selected?: boolean) => {
                const newValues = selected ? values?.concat(option.value!) || [option.value] : values?.filter(v => v !== option.value) || [];
                name && setFieldValue && setFieldValue(name, newValues, true);
                onChange && onChange(option.value!, newValues, selected);
            }}
        />
    </Grid>
    )}
    {showError && name &&
        <Grid item xs={12}>
            <ErrorMessage name={name} />
        </Grid>
    }
</>
